// Headline numbers for the OFAC sanctions list.
//
// GENERATED FILE - do not edit by hand. Refresh with:
//   node scripts/refresh-sanctions.mjs
//
// Split out from sanctionedAddresses.js so that quoting the size of the list
// costs a few bytes rather than the whole list. Generated together, so the two
// cannot disagree.

export const SANCTIONS_SOURCE =
  "https://sanctionslist.ofac.treas.gov/Home/SdnList";
export const SANCTIONS_AS_OF = "2026-09-15";
export const SANCTIONED_ADDRESS_COUNT = 531;
export const SANCTIONED_ENTITY_COUNT = 65;
